import { useState, useEffect, useCallback } from "react";
import { MOBILE_MAX, TABLET_MAX } from "../styles/breakpoints";

const getBreakpoint = width => ({
  isMobile: width <= MOBILE_MAX,
  isTablet: width > MOBILE_MAX && width <= TABLET_MAX,
  isDesktop: width > TABLET_MAX,
});

export const useResponsive = () => {
  const [breakpoint, setBreakpoint] = useState(() =>
    getBreakpoint(typeof window !== "undefined" ? window.innerWidth : 1280),
  );

  const handleResize = useCallback(() => {
    setBreakpoint(getBreakpoint(window.innerWidth));
  }, []);

  useEffect(() => {
    let debounceTimer;
    const debouncedResize = () => {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(handleResize, 100);
    };
    window.addEventListener("resize", debouncedResize);
    return () => {
      window.removeEventListener("resize", debouncedResize);
      clearTimeout(debounceTimer);
    };
  }, [handleResize]);

  return breakpoint;
};
